import React from 'react';

import CatalogProductCard from '@/widgets/CatalogProductCard';
import { catalogItemFromOffer, catalogItemFromProduct, catalogSpecsFromGuarantee } from '@/widgets/CatalogProductCard/mappers';
import { Slider } from '@/widgets/Slider';

import { batteryBadges, isSuggestedBattery } from '@/constants/batteryProduct';

import { ProductType } from '@/server/services/core/product/models';
import { ProductBatteryType } from '@/server/services/core/productBattery/models';
import { OfferContent } from '@/server/services/vendor/models';

const SwiperProducts = ({
    products,
    sourceType,
    mobileCarousel = false
}: {
    products: ProductBatteryType[] | ProductType[] | OfferContent[];
    sourceType: 'all' | 'battery';
    mobileCarousel?: boolean;
}) => {
    const cards = products
        .filter((product) => product.discountPercentage !== 99)
        .map((product) => {
            if (sourceType === 'battery') {
                const batteryProduct = product as ProductBatteryType;
                return (
                    <CatalogProductCard
                        key={batteryProduct.uuid}
                        item={catalogItemFromProduct(batteryProduct)}
                        badge={isSuggestedBattery(batteryProduct) ? 'پیشنهاد ازکی‌سرویس' : undefined}
                        priceNote={`با تحویل باتری قدیمی ${batteryProduct.ampere.toLocaleString('fa-IR')} آمپر`}
                        specs={[
                            ...batteryBadges(batteryProduct).map((badge) => badge.title),
                            ...(catalogSpecsFromGuarantee(batteryProduct.guarantee) ?? [])
                        ]}
                    />
                );
            }

            const offerProduct = product as OfferContent;
            return <CatalogProductCard key={offerProduct.productUuid} item={catalogItemFromOffer(offerProduct)} showSelectButton={false} />;
        });

    return (
        <>
            {sourceType === 'battery' && !mobileCarousel && <div className='flex flex-col gap-4 md:hidden'>{cards}</div>}
            <div className={sourceType === 'battery' && !mobileCarousel ? 'hidden md:block' : undefined}>
                <Slider
                    spaceBetween={16}
                    className='!relative -mx-4 px-2 py-2 pb-4 md:mx-0 md:px-2'
                    navigation={sourceType !== 'battery'}
                    slidesPerView={sourceType === 'battery' ? 1.15 : 1}
                    mousewheel={{
                        forceToAxis: true
                    }}
                    swiperSlideClassName='!h-auto'
                    breakpoints={{
                        300: {
                            slidesPerView: sourceType === 'battery' ? 1.15 : 1
                        },
                        640: {
                            slidesPerView: sourceType === 'battery' ? 2.15 : 2
                        },
                        1024: {
                            slidesPerView: sourceType === 'battery' ? 3.15 : 3
                        },
                        1280: {
                            slidesPerView: sourceType === 'battery' ? 4.15 : 4
                        }
                    }}>
                    {cards}
                </Slider>
            </div>
        </>
    );
};

export default SwiperProducts;
